export default __webpack_public_path__ + "static/media/uploader-oneTouchUltraMini-4.7cf604b9.png";